import { ScopeType, Selector } from 'src/common/types';
import DataStore from 'src/core/stores/data-store';
import FormStore from 'src/core/stores/form-store';
import { CommandResult } from 'src/core/stores/types';

export const LicenseManagerRoleName = 'License Manager';
export const SystemAdminRoleName = 'System Administrator';
export const PartnerAdminRoleName = 'Partner Administrator';
export const GlobalLicenseManagerRoleName = 'Global License Manager';
export const StructmasterUserRoleName = 'StructMaster User';
export const LicenseApproverRoleName = 'License Reviewer';

export interface RolePermissionItem {
  permissionId: string;
  name: string;
  selector: Selector;
}

export interface RoleSummary {
  id: string;
  name: string;
  organizationId: string;
  organization: string;
  selector: Selector;
  permissions: RolePermissionItem[];
  addToScopeTypeCreator?: ScopeType;
}

export interface RoleItem {
  id: string;
  name: string;
  organizationId: string;
  organization: string;
  selector: Selector;
  permissions: RolePermissionItem[];
  addToScopeTypeCreator?: ScopeType;
}

export interface CreateRoleItem {
  name: string;
  organizationId: string;
  selector: Selector;
  permissions?: string[];
  addToScopeTypeCreator?: ScopeType;
}
export interface UpdateRoleItem {
  name: string;
  selector: Selector;
  permissions?: string[];
  addToScopeTypeCreator?: ScopeType;
}

export class RoleSummaryStore extends DataStore<RoleSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/roles`, []);
  }
}

export class RoleItemStore extends FormStore<RoleItem, CreateRoleItem> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/roles`);
  }

  public async update(id: string, item: UpdateRoleItem) {
    return await this.handleCallAsync(async () => {
      try {
        var result = await this.httpService.put<UpdateRoleItem, CommandResult<UpdateRoleItem>>(`${this.baseUrl}/${encodeURIComponent(id)}`, item);
        return result.data;
      } catch {
        return { isSuccess: false };
      }
    });
  }

  public async loadRole(id: string) {
    return await this.handleCallAsync(async () => {
      var response = await this.httpService.get<RoleItem>(`${this.baseUrl}/${encodeURIComponent(id)}`);
      this._state.set((s) => {
        s.item = response.data as RoleItem;
        return s;
      });
      return response.data as RoleItem;
    });
  }

  rolePermissionsBasePath = 'permissions';

  public async addRolePermissions(id: string, permissionIds: string[]) {
    return await this.handleCallAsync(async () => {
      var result = await this.httpService.post(`${this.baseUrl}/${encodeURIComponent(id)}/${this.rolePermissionsBasePath}`, {
        permissions: permissionIds,
      });
      return result.data;
    });
  }

  public async deleteRolePermissions(id: string, permissionIds: string[]) {
    return await this.handleCallAsync(async () => {
      var result = await this.httpService.delete(`${this.baseUrl}/${encodeURIComponent(id)}/${this.rolePermissionsBasePath}`, {
        permissions: permissionIds,
      });
      return result.data;
    });
  }
}
